import type { Capability } from '@portfolio/shared';
import type { JSX } from 'react';

import { Card } from '@/components/ui/Card';

interface CapabilityCardProps {
  capability: Capability;
  headingLevel?: 'h3' | 'h4';
}

export function CapabilityCard({
  capability,
  headingLevel: Heading = 'h3',
}: CapabilityCardProps): JSX.Element {
  return (
    <Card as="li" className="flex flex-col">
      <Heading className="text-lg">{capability.title}</Heading>
      <p className="mt-3 text-sm text-muted">{capability.description}</p>
      <ul className="mt-5 flex flex-col gap-2 border-t border-line pt-4 text-sm text-subtle">
        {capability.points.map((point) => (
          <li key={point} className="flex gap-2">
            <span aria-hidden="true" className="mt-2 size-1.5 shrink-0 rounded-full bg-accent" />
            {point}
          </li>
        ))}
      </ul>
    </Card>
  );
}
